/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';
export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED';
export const RESET_SESSION_EXPIRED = 'RESET_SESSION_EXPIRED';
export const VISIBILITY_PUBLIC = 'public';
export const SET_LICENSE_STATE = 'SET_LICENSE_STATE';
export const NOT_AUTHENTICATED = '401: User is not authenticated';

export const PROJECT_TYPE_STANDARD = 'standard';
export const PROJECT_TYPE_JIRA = 'jira';
export const PROJECT_TYPE_GITLAB = 'gitlab';

export const NOW = new Date();

export const CURRENT_MONTH_FROM = new Date(
  Date.UTC(NOW.getUTCFullYear(), NOW.getUTCMonth(), 1, 0, 0, 0),
);

export const LAST_12_MONTHS_TO = new Date(
  Date.UTC(NOW.getUTCFullYear(), NOW.getUTCMonth(), 0, 23, 59, 59),
);

export const LAST_12_MONTHS_FROM = new Date(
  Date.UTC(
    LAST_12_MONTHS_TO.getUTCFullYear(),
    LAST_12_MONTHS_TO.getUTCMonth() - 11,
    1,
    0,
    0,
    0,
  ),
);
